import { ColSettings } from '../../../../common/model/ColSettings';

type KitContainersColSettings = {
  my: ColSettings;
  actionsMy: ColSettings;
  pr: number;
  containerWidth: ColSettings;
  descriptionWidth: ColSettings;
  statusWidth: ColSettings;
  patientVisitWidth: ColSettings;
  actionsWidth: ColSettings;
};

const cols: KitContainersColSettings = {
  my: {
    xs: 0.5,
    lg: 0,
  },
  actionsMy: {
    xs: 2,
    lg: 0,
  },
  pr: 0.5,
  containerWidth: {
    xs: 12,
    md: 6,
    lg: 2,
  },
  descriptionWidth: {
    xs: 12,
    md: 6,
    lg: 4,
  },
  statusWidth: {
    xs: 12,
    md: 6,
    lg: 3,
  },
  patientVisitWidth: {
    xs: 12,
    md: 6,
    lg: 2,
  },
  actionsWidth: {
    xs: 12,
    lg: 1,
  },
};

export const KitContainersColSettings = {
  cols,
};
